import { render } from "./HeroImage.vue?vue&type=template&id=2972a49a"
import script from "./HeroImage.vue?vue&type=script&lang=js"
export * from "./HeroImage.vue?vue&type=script&lang=js"

import "./HeroImage.vue?vue&type=style&index=0&id=2972a49a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__